import { MultiCityState, MultiCityStatus } from '@fcom/common/interfaces/booking';

import * as MultiCityActions from '../actions/multi-city.actions';

export const initialState: MultiCityState = Object.seal({
  offers: [],
  airlines: {},
  bounds: {},
  fareFamilies: {},
  hasFlightsInUnitedStates: null,
  locations: {},
  selectedFareFamily: null,
  messages: null,
  statusCode: null,
  status: MultiCityStatus.INITIAL,
  surcharges: [],
  selectedItinerary: [],
  hashMap: {},
  requestedMoreFlightOfferIds: [],
  fareFamiliesPerCabin: {},
});

// eslint-disable-next-line complexity
export function multiCityReducer(state = initialState, action: MultiCityActions.ActionsUnion): MultiCityState {
  /* eslint-disable no-fallthrough */
  switch (action.type) {
    case MultiCityActions.setMultiCityOffers.type:
      return {
        ...state,
        ...action.offers,
      };
    case MultiCityActions.addMultiCityOffers.type:
      return {
        ...state,
        offers: [...state.offers, ...(action.offers || [])],
        bounds: {
          ...state.bounds,
          ...(action.bounds || {}),
        },
        locations: {
          ...state.locations,
          ...(action.locations || {}),
        },
        hashMap: {
          ...state.hashMap,
          ...(action.hashMap || {}),
        },
      };
    case MultiCityActions.setMultiCitySelectedItinerary.type:
      return {
        ...state,
        selectedItinerary: action.itinerary,
      };
    case MultiCityActions.addMultiCitySelectedItinerary.type:
      return {
        ...state,
        selectedItinerary: [...state.selectedItinerary, action.itinerary],
      };
    case MultiCityActions.setMultiCitySelectedFareFamily.type:
      return {
        ...state,
        selectedFareFamily: action.fareFamily,
      };
    case MultiCityActions.resetSelections.type:
      return {
        ...state,
        selectedFareFamily: null,
        selectedItinerary: [],
        status: MultiCityStatus.READY,
      };
    case MultiCityActions.reset.type:
      return initialState;
    case MultiCityActions.setStatus.type:
      return {
        ...state,
        status: action.status,
      };
    case MultiCityActions.addRequestedMoreFlightOfferIds.type:
      return {
        ...state,
        requestedMoreFlightOfferIds: [...state.requestedMoreFlightOfferIds, action.offerId],
      };
    default:
      return state;
  }
}
